import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    deviceType: 'lg',
    isMobile: false,
    collapsed: false,
    lang: navigator.language === 'zh-CN' ? 'zh-CN' : 'en-US'
  }),
  actions: {
    toggleDevice(deviceType, collapsed) {
      this.deviceType = deviceType
      this.isMobile = deviceType === 'xs'

      if (collapsed !== undefined) {
        this.collapsed = collapsed
      }
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed
    },
    setLanguage(lang) {
      this.lang = lang
    },
    reset() {
      this.$reset()
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        paths: ['collapsed', 'isFrame'],
        storage: sessionStorage
      }
    ]
  }
})

export default useAppStore
